import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginForm } from '@/components/auth/LoginForm';
import { SignUpForm } from '@/components/auth/SignUpForm';
import { ConfirmSignUpForm } from '@/components/auth/ConfirmSignUpForm';

type AuthView = 'login' | 'signup' | 'confirm';

export const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialView = (location.state as { authView?: AuthView })?.authView ?? 'login';
  const [view, setView] = useState<AuthView>(initialView);
  const [confirmEmail, setConfirmEmail] = useState('');

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname ?? '/';

  const handleLoginSuccess = () => {
    navigate(from, { replace: true });
  };

  const handleNeedConfirmation = (email: string) => {
    setConfirmEmail(email);
    setView('confirm');
  };

  const handleConfirmSuccess = () => {
    setView('login');
  };

  return (
    <div
      className="flex min-h-[80vh] items-center justify-center"
      style={{ padding: 'var(--space-4)' }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '28rem',
          backgroundColor: 'var(--bg-surface)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-8)',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        {view === 'login' && (
          <LoginForm
            onSuccess={handleLoginSuccess}
            onSignUpClick={() => setView('signup')}
          />
        )}
        {view === 'signup' && (
          <SignUpForm
            onNeedConfirmation={handleNeedConfirmation}
            onSignInClick={() => setView('login')}
          />
        )}
        {view === 'confirm' && (
          <ConfirmSignUpForm
            email={confirmEmail}
            onSuccess={handleConfirmSuccess}
          />
        )}
      </div>
    </div>
  );
};
